import base64url from 'base64url';

export const base64UrlToUuid = (base64Url: string): string => base64url
  .decode(base64Url, 'hex')
  .replace(/(.{8})(.{4})(.{4})(.{4})(.{12})/, '$1-$2-$3-$4-$5');
